import { ActivatedRoute } from '@angular/router';
import { AfterViewInit, Component, OnDestroy, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Subscription, zip } from 'rxjs';
import { tap } from 'rxjs/operators';

import { AssignmentPage } from '../assignment.page';
import { BasePage } from '../../base.page';
import {
    ContractInterface,
    ContractSignatureType,
    GetContractSignatoriesUseCase,
    GetContractUseCase,
    OrderClientInterface,
    SignModelUseCase,
} from '../../../../core';
import { ErrorDialog } from '../../../ui/dialog/error/error.dialog';
import { ParentEvents } from '../../../utils/parent-events.service';

import { environment } from '../../../../../environments/environment';

@Component({
    templateUrl: './assignment-sign.page.html',
    styleUrls: ['./assignment-sign.page.scss'],
})
export class AssignmentSignPage extends BasePage implements AfterViewInit, OnDestroy, OnInit {
    private backSubscription: Subscription;

    public contract: ContractInterface;
    public participants: OrderClientInterface[] = [];
    public isClientPortal = environment.portalClient;

    constructor(
        assignmentPage: AssignmentPage,
        parentEvents: ParentEvents,
        private dialog: MatDialog,
        private getContractUseCase: GetContractUseCase,
        private getContractSignatoriesUseCase: GetContractSignatoriesUseCase,
        private route: ActivatedRoute,
        private signModelUseCase: SignModelUseCase
    ) {
        super(parentEvents);
        assignmentPage.showBackButton();
        this.backSubscription = assignmentPage.back.subscribe(() => {
            window.history.back();
        });
    }

    get signedBy(): 'all' | 'one' {
        if (this.participants.length > 1){
            return 'all';
        }
        return this.contract && this.contract.signatureType === ContractSignatureType.JOINT ? 'all' : 'one';
    }

    ngOnInit(): void {
        this.getSignatories();
    }

    private getSignatories(): void {
        zip(
            this.getContractUseCase.bind().pipe(
                tap((transaction) =>
                    transaction.fold(
                        (contract) => (this.contract = contract),
                        (throwable) =>
                            this.dialog.open(ErrorDialog, {
                                data: { text: throwable.message },
                            })
                    )
                )
            ),
            this.getContractSignatoriesUseCase.bind({}).pipe(
                tap((transaction) =>
                    transaction.fold(
                        (signatories) => {
                            this.participants = signatories;
                            this.participants.forEach((participant) => (participant.signatureType = undefined));
                        },
                        () =>
                            this.dialog.open(ErrorDialog, {
                                data: { text: 'error.selected-product-not-signatories' },
                            })
                    )
                )
            )
        ).subscribe();
    }

    ngOnDestroy() {
        this.backSubscription.unsubscribe();
    }

    onSubmit() {
        this.route.data.subscribe((data) => {
            if (!!data.fee) {
                this.signModelUseCase
                    .bind({
                        signatories: this.participants.filter((participant) => !!participant.signatureType),
                        modelId: data.fee.modelId,
                    })
                    .subscribe((transaction) => {
                        transaction.fold(
                            () => this.parentEvents.cancel(),
                            (throwable) =>
                                this.dialog.open(ErrorDialog, {
                                    data: { text: throwable.message },
                                })
                        );
                    });
            }
        });
    }
}
